import {useColorMode} from '../../hooks/use-color-mode.js'
import type {IconButtonProps} from '@chakra-ui/react'
import {ClientOnly, IconButton, Skeleton} from '@chakra-ui/react'
import * as React from 'react'
import {LuMoon, LuSun} from 'react-icons/lu'

function ColorModeIcon() {
  const {colorMode} = useColorMode()
  return colorMode === 'dark' ? <LuMoon /> : <LuSun />
}

// oxlint-disable-next-line no-empty-object-type
interface ColorModeButtonProps extends Omit<IconButtonProps, 'aria-label'> {}

export const ThemeSwitcher = React.forwardRef<HTMLButtonElement, ColorModeButtonProps>(
  function ColorModeButton(props, ref) {
    const {toggleColorMode} = useColorMode()
    return (
      <ClientOnly fallback={<Skeleton boxSize="9" />}>
        <IconButton
          onClick={toggleColorMode}
          variant="ghost"
          aria-label="Toggle color mode"
          size="sm"
          ref={ref}
          {...props}
          css={{
            _icon: {
              width: '5',
              height: '5',
            },
          }}
        >
          <ColorModeIcon />
        </IconButton>
      </ClientOnly>
    )
  }
)
